export const not_started = '1';
export const in_progress = '2';
export const submitted = '3';



/** WEBPACK FOOTER **
 ** ./src/constants/establishmentFilterConstants.js
 **/